module.exports = __webpack_public_path__ + "static/fonts/Arita-buriB.db12e83.woff";